/**
 * @generated SignedSource<<a1bf8bf00678ee844d084694407a469c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStartTryNextQuery$variables = Record<PropertyKey, never>;
export type SessionStartTryNextQuery$data = {
  readonly me: {
    readonly learner: {
      readonly familyWeek: {
        readonly talks: ReadonlyArray<{
          readonly startedAt: any;
          readonly topic: string | null | undefined;
        }>;
      } | null | undefined;
      readonly id: string;
      readonly storyBooks: ReadonlyArray<{
        readonly cover: string;
        readonly coverImage: string;
        readonly finished: boolean;
        readonly id: string;
        readonly number: number;
        readonly title: string;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type SessionStartTryNextQuery = {
  response: SessionStartTryNextQuery$data;
  variables: SessionStartTryNextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoryBook",
            "kind": "LinkedField",
            "name": "storyBooks",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cover",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coverImage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FamilyWeek",
            "kind": "LinkedField",
            "name": "familyWeek",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FamilyTalk",
                "kind": "LinkedField",
                "name": "talks",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topic",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionStartTryNextQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionStartTryNextQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "8ed9e96dd26b5fb77a398cdd26cb8639",
    "id": null,
    "metadata": {},
    "name": "SessionStartTryNextQuery",
    "operationKind": "query",
    "text": "query SessionStartTryNextQuery {\n  me {\n    learner {\n      id\n      storyBooks {\n        id\n        number\n        title\n        cover\n        coverImage\n        finished\n      }\n      familyWeek {\n        talks {\n          startedAt\n          topic\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94ac7876b08253432b6141208f49dda7";

export default node;
